import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditKeywords from "./components/ListAllAuditKeywords";

export default function AuditKeywordstable() {
    const { translate } = useLang();
    
    

    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Keywords')}`} />
            <ListAllAuditKeywords />
        </>
    )
}